export const COLORS = {
  primary: '#00FFB9',
} as const;

// Call Volume Chart Colors
export const CALL_VOLUME_COLORS = {
  INBOUND: {
    light: '#23407A',
    dark: '#1681F6'
  },
  OUTBOUND: {
    light: '#00FEC1',
    dark: '#00FEC1'
  },
  INBOUND_DIRECT: {
    light: '#FFB300',
    dark: '#FFB300'
  },
  INTERNAL: {
    light: '#8E44AD',
    dark: '#8E44AD'
  }
} as const;

export const LINE_CHART_COLORS = {
  LINE: {
    light: '#23407A',
    dark: '#1681F6'
  },
  DOT_FILL: {
    light: 'white',
    dark: '#0f172a'
  },
  TOOLTIP_TEXT: {
    light: '#1e3a8a', // blue-900
    dark: '#60a5fa'  // blue-400
  }
} as const; 